import { supabase } from "../supabase/supabaseClient";

export async function joinOrg(userId, orgId, role) {
  const normalizedRole = (role || "").toString().toLowerCase();
  // guard against invalid roles early
  const allowed = ["scout", "coach", "recruiter", "admin"];
  if (!allowed.includes(normalizedRole)) {
    return { error: new Error(`Invalid role: ${role}`), data: null };
  }

  const { data: authData, error: authError } = await supabase.auth.getUser();
  if (authError) {
    return { error: authError, data: null };
  }

  const authUserId = authData?.user?.id;
  if (!authUserId) {
    return { error: new Error("No authenticated user found for org membership insert"), data: null };
  }

  const targetUserId = authUserId || userId;

  return supabase
    .from("org_memberships")
    .insert({ user_id: targetUserId, org_id: orgId, orgrole: normalizedRole })
    .select("*")
    .single();
}

export async function removeMember(orgId, memberUserId) {
  return supabase
    .from("org_memberships")
    .delete()
    .eq("org_id", orgId)
    .eq("user_id", memberUserId);
}
